import { render, staticRenderFns } from "./SettingsBirthdays.vue?vue&type=template&id=7763d0be&scoped=true&"
import script from "./SettingsBirthdays.vue?vue&type=script&lang=ts&"
export * from "./SettingsBirthdays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763d0be",
  null
  
)

export default component.exports